import { useEffect, useMemo, useState } from "react";
import prepareForOptions from "~services/utils/prepareForOptions";
import { db } from "~/db/db";
import useSelect from "~components/Form/hooks/useSelect";
import useGrupoSegmento from "./useGrupoSegmento";

const useTodosSegmentos = (todosOsClientes, trilha = null, formikRef = null, config = {}) => {
  const { salvarLocalStorage = false, chave } = config;

  const segmentoSelect = useSelect("segmento");

  const { gruposSegmentos} = useGrupoSegmento({formikRef, trilha});

  const [segmentos, setSegmentos] = useState([]);
  const [fila, setFila] = useState(null);
  const [onSegmento, setOnSegmento] = useState(false);
  const [segmento, setSegmento] = useState(0);

  useEffect(() => {
    const fetchSegmentos = async (clientes) => {
      const segmentoIds = new Set();

      clientes.forEach((cliente) => {
        const segmentoNome = cliente?.segmento;
        const segmentoId = cliente?.segmentoId;

        if (segmentoId && segmentoNome) {
          segmentoIds.add(segmentoId);
        }
      });

      const results = segmentoIds.size
        ? (await db.segmento.bulkGet(Array.from(segmentoIds))).filter((item) => item?.ativo)
        : [];

      if (clientes.length > 0) {
         let segmentosFiltrados = results;

        if (gruposSegmentos?.length) {
          const idsGrupos = new Set(gruposSegmentos.map(g => g.id));

          segmentosFiltrados = results.filter(seg => idsGrupos.has(seg.grupoSegmentoId));
        }

        setSegmentos(segmentosFiltrados);
      } else {
        setSegmentos([]);
      }
    };

    if (Array.isArray(todosOsClientes)) {
      fetchSegmentos(todosOsClientes);
    }
  }, [todosOsClientes, trilha, gruposSegmentos]);


  const optionsSegmento = useMemo(() => {
    return prepareForOptions(
      (segmentos || []).sort((a, b) => a.nome.localeCompare(b.nome)),
      ["nome"],
      "id"
    );
  }, [segmentos]);

  function onChangeSegmento(e) {
    setOnSegmento(e?.value > 0);
    segmentoSelect.upDateValue(e?.value);
    segmentoSelect.upDateDefaultValue(e || "");
    if (salvarLocalStorage) {
      localStorage.setItem(chave, JSON.stringify(e));
    }
    setSegmento(e?.value || 0);
  }

    useEffect(() => {
    if(salvarLocalStorage){
      const segmentoSalvo = localStorage.getItem(chave);

      if (segmentoSalvo) {
        const segmentoObj = JSON.parse(segmentoSalvo);
        setSegmento(segmentoObj.value);
        onChangeSegmento(segmentoObj);
        setFila(segmentoObj.value);
      }
    }
  }, [])

  function SetSelectSegmento(id, setSegmentosInitialized = undefined) {
    if (optionsSegmento?.length) {
      const segmento = optionsSegmento.find((item) => item.value == id);
      if (segmento) {
        onChangeSegmento(segmento);
        if (setSegmentosInitialized !== undefined) setSegmentosInitialized(true);
      }
      setFila(null);
    } else {
      setFila(id);
    }
  }

  useEffect(() => {
    if (fila && optionsSegmento?.length > 0) {
      SetSelectSegmento(fila);
    }
  }, [fila, optionsSegmento]);

  function CleanForFilter(option) {
    onChangeSegmento(option);
  }

  return {
    segmentos,
    optionsSegmento,
    segmento,
    onSegmento,
    segmentoSelect,
    onChangeSegmento,
    SetSelectSegmento,
    CleanForFilter,
  };
};

export default useTodosSegmentos;
